<template>
  <Layout>
    <div class="row bg-white">
      <div class="col-lg-8 col-md-6 pl-0 pr-0 content-left banner-login-desktop">
        <!-- <img
          class="banner-login-desktop"
          src="@assets/images/login-bg.jpg"
        /> -->
      </div>
      <div class="col-lg-4 col-md-12 content-right">
        <div class="mx-auto login-form-content">
          <div class="text-center">
            <img
              class="img-fluid logo-login"
              src="@assets/images/medellin.5f5c6332.png"
              alt=""
            />
          </div>
          <div class="text-center mb-4">
            <h1 class="title-login">
              Caracterización 360
            </h1>
            <hr />
          </div>
          <div class="text-left mb-3">
            <span class="subtitle-login"
              >Ingrese sus datos para iniciar sesión</span
            >
          </div>
          <form-login />
          <hr />
          <div class="text-center">
            <span class="forgot-password">¿Olvidó su contraseña?</span>
            <a href="https://www.medellin.gov.co" class="recover-password" target="_blank">Recupérala AQUÍ</a>
          </div>
        </div>
        <footer class="footer-login">
          <span>
            <strong class="powered-login">Powered by</strong> Secretaría de Innovación Digital
          </span>
        </footer>
      </div>
    </div>
  </Layout>
</template>

<script>
  import Layout from '@layouts/auth'
  import { authMethods } from '@state/helpers'
  import getSecret from '@utils/get-secret'
  // import DisableAutocomplete from 'vue-disable-autocomplete'
  // import Vue from 'vue'
  // import Network from '@plugins/Network'
  import FormLogin from './FormLogin'

  // Vue.use(DisableAutocomplete)

  export default {
    page: {
      title: 'Acceso',
      meta: [{ name: 'description', content: `Acceso - ${getSecret('TITLE')}` }], // Used in a html meta tag,
    },
    components: { Layout, FormLogin },
    data() {
      return {
        type_document: '',
        username: '',
        password: '',
        authError: null,
        tryingToLogIn: false,
        isAuthError: false,
        hidePassword: true,
      }
    },
    computed: {
      getCompanyInfo: function() {
        return this.$store.state.appAuth.companyInfo || null
      },
      passwordType() {
        return this.hidePassword ? 'password' : 'text'
      },
      passwordIcon() {
        return this.hidePassword ? 'text-muted' : 'text-info'
      },
      passwordText() {
        return this.hidePassword ? 'VER' : 'OCULTAR'
      },
    },
    mounted() {
      if (this.$route.params && 'expiredSession' in this.$route.params) {
        this.$generate_noty('error', this.$t('expired_session'))
      }
      if (
        'redirectFrom' in this.$route.query &&
        this.$route.query.redirectFrom !== '/'
      ) {
        this.$generate_noty('warn', this.$t('login_required'))
      }
    },
    methods: {
      ...authMethods,
      // Try to log the user in with the username
      // and password they provided.
      removeReadonly(event) {
        event.preventDefault()
        if (event.target.getAttribute('readonly') == 'readonly') {
          event.target.removeAttribute('readonly')
        }
      },
    },
  }
</script>

<style lang="scss">
/* Form */
.login-form-content {
  width: 297px;
  // margin-left: 31px;
  min-height: 100vh;
  position: relative;
}

.form-group {
  margin-bottom: 12px;
}
/* Input */
.label_input {
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  letter-spacing: 0px;
  opacity: 1;
  color: black;
  margin-bottom: 13px;
  font-weight: 600;
}

.form-control-login {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 0.5px solid #707070;
  border-radius: 6px;
  opacity: 1;
  width: 100%;
  height: 35px;
  margin-bottom: 0;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  padding-left: 25px;
}

input[type="text"]:focus,
input[type="password"]:focus {
  border: 1px solid #707070 !important;
  outline: 0 none;
}

.form-control-login.error {
  border: 1px solid #AD0808;
}

.error-form {
  border: 1px solid #AD0808 !important;
}

.alert {
  font-size: 14px !important;
}

.banner-login-desktop {
  // top: 63px !important;
  // height: 100%;
  // height: 682px;
  max-width: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;
  top: 0;
  // position: absolute;
  background-image: url('../../assets/images/login-bg.jpg');
  // background-attachment: fixed;
  object-fit: cover;
}

.logo-login {
  width: 164px;
  height: 115px;
  margin-top: 87.45px;
}

.title-login {
  text-align: center;
  font-family: 'Montserrat', sans-serif;
  letter-spacing: 0px;
  color: #005CC6;
  font-size: 18px;
  margin-top: 18.43px;
  font-weight: 400;
}


.subtitle-login {
  margin-top: 53px;
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  color: black;
  font-size: 14px;
  letter-spacing: 0px;
  opacity: 1;
}

.content-link {
  margin-top: 0px;
  /* display: flex;
  align-items: center; */
}

.type_document {
  width: 140px;
}

.document_identity {
  display: flex;
  gap: 16px;
  justify-content: space-between;
}

.checkbox-login input[type="checkbox"] + label:before {
	content: "";
	width: 17px;
  height: 17px;
	float: left;
	margin: 0.3em 0.5em 0 0;
	background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #95C8DA;
  border-radius: 4px;
  opacity: 1;
}

.checkbox-login input[type="checkbox"]:checked + label:before {
	border-color: #95C8DA;
}

.checkbox-login input[type="checkbox"]:checked + label:after {
  content: "";
  opacity: 1;
  width: 12px;
  height: 6px;
  border: 3px solid #0C0C0C;
  float: left;
  margin-left: -1.65em;
  border-right: 0;
  border-top: 0;
  margin-top: 8px;
  transform: rotate(-55deg);
}

.checkbox-login input[type="checkbox"] {
	display: none;
}

.checkbox-login input[type="checkbox"] + label {
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
  color: #000000CC;
  letter-spacing: 0px;
  opacity: 1;
  cursor: pointer;
  font-weight: 400;
}

// .label-checkbox {
//   display: flex;
//   align-items: center;
// }

.content-btn-login {
  display: flex;
  justify-content: space-between;
  margin-top: 48px;
  margin-bottom: 30px;
}

.btn-register {
  background-color: #ffffff;
  border: 1px solid #1FAEEF;
  font-size: 12px;
  width: 120px;
  height: 38px;
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  border-radius: 1.5rem;
  color: #1FAEEF;
  letter-spacing: 0px;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}


.btn-login-form {
  background-color: #1FAEEF;
  border: none;
  font-size: 12px;
  width: 120px;
  height: 38px;
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  border-radius: 1.5rem;
  color: #ffffff;
  letter-spacing: 0px;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-login-form:disabled {
  background: #E2E2E2 0% 0% no-repeat padding-box;
  color: #ffffff;
}

.btn-register:hover,
.btn-login-form:hover {
  color: white !important;
  background: #F28C02 !important;
  border: 1px solid #F28C02;
}

/* spinner */
.loader {
  border: 0.25rem solid #f3f3f3;
  border-radius: 50%;
  border-top: 0.25rem solid #1FAEEF;
  width: 1.2rem;
  height: 1.2rem;
  animation: spin 1s linear infinite;
  margin-left: 0.625rem;
  -webkit-animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.input-password {
  position: relative;
}

.input-password input {
  padding-right: 3.5rem;
}

.icon_eye {
	position: absolute;
  display: block;
  bottom: 0.55rem;
  right: .6rem;
  user-select: none;
  cursor: pointer;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
	font-size: 10px;
	color: #1FAEEF;
}

.color-icon {
  color: #F28C02;
}

.icon_eye span {
  position: absolute;
}

.forgot-password {
  text-align: left;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
  margin-right: 5px;
}

.recover-password {
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  font-weight: bold;
  color: #1FAEEF;
  letter-spacing: 0px;
  opacity: 1;
  cursor: pointer;
}

.footer-login {
  background-color: #ffffff;
  position: relative;
  right: 0;
  left: 0;
  bottom: 0;
  height: 20px;
  text-align: center;
  margin-bottom: 21px;
  margin-top: 53px;
  // width: 297px;
  // margin-left: 31px;
}

.footer-login span {
  font-family: 'Work Sans', sans-serif;
  font-size: 11px;
  text-align: center;
  font: normal normal normal 11px/13px Work Sans;
  letter-spacing: 0px;
  color: #696969;
}

.powered-login {
  color: #696969;
  font-weight: 400;
}

.box {
  display: flex;
  justify-content: space-between;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  border: 1px solid #A71300;
  background: #f7dcdc 0% 0% no-repeat padding-box;
  opacity: 1;
  color: #A71300;
  font-family: 'Work Sans', sans-serif;
  font-size: 12px;
  margin-top: 25px;
}

.box p {
  padding: 0;
  margin: 0;
}

.box  span {
  font-size: 18px;
  cursor: pointer;
}

/*** VERSION ESCRITORIO Y TABLETS PANTALLS GRANDE ***/
@media only screen and (min-width: 768px) and (max-width: 1200px) {}

@media (width: 1024px) {}

/*** VERSION TABLETS ***/
@media only screen and (min-width: 768px) and (max-width: 992px)
{
  .content-left {
    display: none !important;
  }

  .content-right {
    width: 100%;
  }
}

/*** VERSION CELULAR ***/
@media only screen and (max-width: 767px)
{
  .content-left {
    display: none !important;
  }

  .logo-login {
    width: 148px;
    height: 104px;
    margin-top: 24.83px;
  }
  
}

/*** VERSION CELULAR PEQUEÑO ***/
@media only screen and (max-width: 320px)
{
  .content-left {
    display: none !important;
  }
}
</style>
